import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import Announcement from 'components/Announcement'
import { AnnouncementType } from 'components/Announcement/Announcement'
import { Colour } from 'components/variables'
import { LOGO } from 'Icon/logo'
import { refreshCurrentTotal } from '../../data/api/order'
import { AppState } from '../../data/state'
import AbstractTrigger from '../triggers/abstractTrigger'
import BucketListTrigger from '../triggers/bucket-list/BucketListTrigger'

interface PriceErrorProps {
  priceError: any | undefined
  dismissPriceError: () => void
  colour?: Colour
  forceHide?: boolean
}

interface BucketListTriggerState {
  show: boolean
}

class PriceErrorNotification extends AbstractTrigger<
  PriceErrorProps,
  BucketListTriggerState
> {
  public timerLength = 10000
  constructor(props: PriceErrorProps) {
    super(props)
    this.state = {
      show: false,
    }
  }

  public updateShow(props: PriceErrorProps) {
    if (!props.priceError) {
      return
    }

    if (props.forceHide) {
      this.dismiss()
    } else {
      this.setState({ show: true })
      this.startTimer(false)
    }
  }

  public render() {
    const { show } = this.state
    const { colour } = this.props
    return (
      <Announcement
        type={AnnouncementType.Info}
        show={show}
        icon={LOGO.logo}
        colour={colour}
        onClose={this.dismiss}
      >
        <p>
          <DisplayContent contentKey="no-price-notification">
            No price found, please add more cities.
          </DisplayContent>
        </p>
      </Announcement>
    )
  }

  private dismiss = () => {
    this.props.dismissPriceError()
    this.onClose()
  }
}

export default connect(
  (state: AppState) => ({
    priceError: state.ui.priceError,
  }),
  dispatch => ({
    dismissPriceError: () => {
      dispatch(actions.change('ui.priceError', undefined))
    },
  }),
)(PriceErrorNotification)
